/**
 * Type guard to check if a value is a string.
 *
 * @param {unknown} value - The value to check.
 * @returns {boolean} True if the value is a string, false otherwise.
 *
 * @example
 * if (isString(someValue)) {
 *   // someValue is typed as string here
 *   console.log(someValue.toUpperCase());
 * }
 */
export const isString = (value: unknown): value is string => {
    return typeof value === 'string';
};
